import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=a45fdb44&scoped=true"
import script from "./TreeView.vue?vue&type=script&lang=js"
export * from "./TreeView.vue?vue&type=script&lang=js"
import style0 from "./TreeView.vue?vue&type=style&index=0&id=a45fdb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45fdb44",
  null
  
)

export default component.exports